<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  data() {
    return {
      // requestType: 'GET',
    };
  },
  mounted() {
    this.getConfigList('reward_dealers_for_terminal_scanning_and_storage_report_list');
  },
  methods: {
  },
};
</script>
